import { Navigate } from 'react-router-dom';

const WORKSPACE_ROLES = new Set(['company_admin', 'company_manager', 'company_staff']);

const WorkspaceRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace state={{ from: '/workspace' }} />;
  }

  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const role = String(user?.role || '');
    const hasCompany = Boolean(user?.company?._id || user?.company);
    if (!WORKSPACE_ROLES.has(role) && !hasCompany) {
      return <Navigate to="/host" replace />;
    }
    return children;
  } catch {
    return <Navigate to="/login" replace />;
  }
};

export default WorkspaceRoute;
